module.exports = __webpack_public_path__ + "static/media/whishlist-icon.b772c0b2.svg";